import Vue from 'vue';
import '@/assets/stylesheets/v2/_base-subtitle.scss';
export default Vue.extend({
    props: {
        text: {
            type: String,
            required: true,
        },
        styles: {
            type: String,
            required: false,
            default: '',
        },
    },
    render(createElement) {
        return createElement('div', {
            class: `base-subtitle ${this.styles}`,
        }, this.text);
    },
});
